"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
function Item(_a) {
    var children = _a.children, status = _a.status, className = _a.className;
    var classNames = storybook_1.Helpers.classNames('storybook-lists-item-row', "storybook-lists-item-" + status, className);
    return react_1.default.createElement("dt", { className: classNames },
        react_1.default.createElement("div", { className: 'storybook-lists-item-body' }, children));
}
exports.default = Item;
Item.propTypes = {
    /**
     * The video object
     */
    children: prop_types_1.default.any,
    /**
     * Add the status
     */
    status: prop_types_1.default.oneOf(['default', 'enabled', 'disabled']),
};
Item.defaultProps = {
    status: 'default',
};
